export default function (params) {
  const data = params.data;
  const width = params.width;
  const height = params.height;
  const radius = params.radius;
  const innerRadius = params.innerRadius;
  const legendItemSize = params.legendItemSize;
  const legendSpacing = params.legendSpacing;
  const legend_array = params.legend_array;

  const svg = d3
    .select("#energyChart")
    .append("svg")
    .attr("id", "pie-svg")
    .attr("width", width)
    .attr("height", height);

  const pie = d3.pie().value((2 * Math.PI * radius) / data.length);

  const path = d3
    .arc()
    .innerRadius(innerRadius)
    .outerRadius(radius - width * 0.1);

  svg
    .selectAll("path")
    .data(pie(data))
    .enter()
    .append("path")
    .attr("fill", (d) => d.data.color)
    .attr("d", path)
    .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

  //Initialize legend
  const legend = d3
    .select("#legend")
    .append("svg")
    .attr("id", "legend-svg")
    .attr('width', "100px")
    .attr('height', "50px")
    .selectAll(".legendItem")
    .data(legend_array);

  //Create legend items
  legend
    .enter()
    .append("rect")
    .attr("class", "legendItem")
    .attr("width", legendItemSize)
    .attr("height", legendItemSize)
    .style("fill", (d) => d[0])
    .attr(
      "transform",
      (d, i) => `translate(0, ${(legendItemSize + legendSpacing) * i})`
    );

  //Create legend labels
  legend
    .enter()
    .append("text")
    .attr("x", legendItemSize + 10)
    .attr("y", (d, i) => (legendItemSize + legendSpacing) * i + 12)
    .text((d) => d[1]);
}
